import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosReq } from "@/lib/axios";
import { EventGallery } from "../types";
import { toast } from "sonner";
import { queryClient } from "@/lib/react-query" 

export const useGetGalleryApproval = () => {

  const request = async (): Promise<EventGallery[]> => {
    const response = await axiosReq.get('/api/landing/gallery-hitl/');
    return response.data
  }

  const { data: approvalGallery } = useQuery({
    queryKey: ["admin-gallery"],
    queryFn: request
  })

  return { approvalGallery }
}

export const useApproveImagesPost = () => {
  const request = async (str: string, image_id: number) => {
    const response = await axiosReq.post('/api/approval/save-image-post/', {
      post_id: parseInt(str),
      image_id
    })

    return response.data
  }

  const { mutate: approveImage, status } = useMutation({
    mutationFn: async ({ image_id, postIds }: { postIds: string[], image_id: number }) => {
      return await Promise.all(postIds.map(str => request(str, image_id)))
    },
    onSuccess: () => {
      toast.success("Image approved successfully")
      queryClient.invalidateQueries({
        queryKey: ["admin-gallery"]
      })
    }
  })

  return { approveImage, status }
}

type ImageUploadArgs = {
  catalogue: string,
  user: string,
  media_file: File,
  prompt: string
}

export const useUploadPostImage = () => {

  const request = async (data: ImageUploadArgs): Promise<{
    image_path: string,
    image_id: number
  }> => {

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const response = await axiosReq.post('/api/approval/upload-post-media/', data, config);
    return response.data;
  };

  const { mutate: uploadImage, data, isSuccess, isPending } = useMutation({
    mutationFn: request,
    onSuccess: (data) => {
      toast.success("Image uploaded successfully");
      return data;
    },
    onError: (error) => {
      toast.error("Failed to upload image");
      console.error("Image upload error:", error);
    }
  });

  return { uploadImage, isSuccess, data, isPending };
};

export type Catalog = {
  image_url: string
  name: string,
  unique_identifier: string,
}

export const useGetCatalog = (open: boolean) => {

  const request = async (): Promise<{
    catalogue: Catalog[]
  }> => {
    const response = await axiosReq.get('/api/landing/catalogue/')
    return response.data
  }

  const { data: catalogData } = useQuery({
    queryKey: ["catalog"],
    queryFn: request,
    enabled: open
  })

  return { catalogData }
}

